import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

import { header } from './_constants'
import { isValidSelector } from './_helpers'

gsap.registerPlugin(ScrollToPlugin)

export function scrollTo(y, options = {}) {
  const headerHeight = header.clientHeight

  if (options.headerOffset && y >= headerHeight) {
    y -= headerHeight
  }
  
  window.scrollTo({ top: y, behavior: 'instant' })
  return Promise.resolve()
}

export function scrollToElement(element, options = { headerOffset: true }) {
  const currPos = window.scrollY || document.documentElement.scrollTop
  const y = currPos + element.getBoundingClientRect().top
  return scrollTo(y, options)
}

export default function initScrollTo(page) {
  const { location, history } = window
  const element =
    location.hash.length &&
    isValidSelector(page, location.hash) &&
    page.querySelector(location.hash)

  const recursiveScroll = (count = 0) => {
    console.log('recursive scroll')
    if (count > 2) return // prevent infinite scroll
    const startOffset = element.offsetTop
    scrollTo(startOffset).then(() => {
      // while document was being automatically scrolled down, the position of target element could've changed
      // due to layout shifts caused by things like lazy loading of images
      if (element.offsetTop !== startOffset) {
        recursiveScroll(count + 1)
      }
    })
  }
  if (
    document.documentElement.classList.contains('barba-initialized') &&
    element
  ) {
    recursiveScroll()
  }

  page.querySelectorAll('[data-scroll-to]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault()

      const el = page.querySelector(`#${e.target.dataset.scrollTo}`)

      el && scrollTo(el.offsetTop)
      history.pushState(null, '', `#${el.id}`)
    })
  })
}
